/* Movimiento SP2. Regla dura: el contenido es visible por defecto.
   La clase que oculta solo se aplica DESPUES de que el observer quedo armado,
   y hay un failsafe que revela todo pase lo que pase. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var FAILSAFE = 1600;
  var io, timer;

  function revealAll() {
    root.classList.remove('sp2-anim');
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  function markIn(el) {
    el.classList.add('is-in');
    var kids = el.querySelectorAll('[data-stagger]');
    for (var i = 0; i < kids.length; i++) kids[i].style.transitionDelay = (i * 70) + 'ms';
  }

  function setup() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;

    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        markIn(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    root.classList.add('sp2-anim');

    els.forEach(function (el) {
      // lo que ya esta a la vista entra de inmediato, sin esperar al observer
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) markIn(el);
      else io.observe(el);
    });

    clearTimeout(timer);
    timer = setTimeout(revealAll, FAILSAFE);
  }

  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', setup);
  else setup();
  addEventListener('load', setup);
  // el editor de temas re-renderiza secciones
  document.addEventListener('shopify:section:load', setup);

  /* contador */
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, to = parseFloat(el.dataset.count || '0'), suf = el.dataset.suffix || '', t0 = 0;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 900);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step); cio.unobserve(el);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

  /* parallax hero, solo desktop */
  var hero = document.querySelector('[data-parallax]');
  if (hero && innerWidth >= 860) {
    var t = false;
    addEventListener('scroll', function () {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var r = hero.getBoundingClientRect();
        var p = Math.max(-1, Math.min(1, r.top / innerHeight));
        hero.style.setProperty('--py', (p * 22).toFixed(1) + 'px');
        t = false;
      });
    }, { passive: true });
  }
})();
